import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class SrcMappingFee {

  @JsonProperty()
  id: number;

  @JsonProperty()
  sourceCode: string | undefined;

  @JsonProperty()
  crystalExchangeCode: string | undefined;

  @JsonProperty()
  sourceExecutionFee: string | undefined;

  @JsonProperty()
  crystalExecutionFee: string | undefined;

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
